import store from '../../store'

export default (to, from, next) => {
  if (store.getters.user) {
    if (store.getters.user.type.toLowerCase() === 'admin') next()
    else {
      const appMsg = {
        type: 'error',
        msg: 'No permission to view that page'
      }
      store.dispatch('showAppMsg', appMsg)
      next('/')
    }
  } else {
    const appMsg = {
      type: 'error',
      msg: 'Please login'
    }
    store.dispatch('showAppMsg', appMsg)
    store.dispatch('setUserRoute', to.fullPath)
    next('/sign-in')
  }
}



// WEBPACK FOOTER //
// ./src/router/general/adminGuard.js